import { createContext, useEffect, useReducer } from "react";
import { useParams } from "react-router-dom";

import Reducer from "./reducer";
import { initialState } from "./initialState";
import steps from "./components/steps";
import { setStep } from "../storage/step";
import { fetchCommonSettings, fetchUnregisteredFtm } from "./service";
import PageLocading from "../common/PageLoading";

const Context = createContext();

const Provider = ({ children }) => {
    const { key } = useParams();
    const [state, dispatch] = useReducer(Reducer, initialState);

    const isStepIdValid = state.step?.stepId >= 1;

    useEffect(() => {
        const loadFtmData = async () => {
            try {
                const settingsResponse = await fetchCommonSettings();
                dispatch({ type: "SET_COMMON_SETTINGS", commonSettings: settingsResponse.data });

                if (settingsResponse && key) {
                    const response = await fetchUnregisteredFtm(key);
                    dispatch({
                        type: "SETUP_DETAILS",
                        ftm: response?.ftm ?? null,
                        step: steps.find((step) => step.stepId === response?.ftm?.ftm_stage_id) ?? {stepId: response?.ftm?.ftm_stage_id, name: "Unknown Step"},
                        commonSettings: settingsResponse.data,
                        isCompletedRegistration: response?.ftm?.ftm_is_approved_terms_and_conditions === 1 ? true : false
                    });
                }
            } catch (error) {
                console.error("Error loading FTM data:", error);
            } finally {
                dispatch({ type: "LOADED" });
            }
        };

        loadFtmData();
    }, [isStepIdValid, key]);

    const updateCurrentStep = (stepId) => {
        const step = steps.find((step) => step.stepId === stepId);
        if (step) {
            dispatch({ type: "UPDATE_CURRENT_STEP", step: step });
            setStep(stepId);
        }
    }

    return (
        <Context.Provider value={{ state, dispatch, updateCurrentStep }}>
            {state.loading ? <PageLocading /> : children}
        </Context.Provider>
    );
}

export { Context, Provider };